<template>
  <b-form @submit="onSubmit">
    <!-- quantity and net_kilograms -->
    <b-row>
      <b-col>
        <b-form-group label="Pallet" label-for="item">
          <b-form-select
            id="item"
            v-model="item"
            type="number"
            min="0"
            :disabled="loading || hereLoading"
            required
            :options="palletList"
            @change="handlePalletChange($event)"
          ></b-form-select>
        </b-form-group>
        <b-form-group label="Kilos Brutos" label-for="gross_kilograms">
          <b-form-input
            id="gross_kilograms"
            v-model="gross_kilograms"
            type="number"
            min="0"
            disabled
            required
          ></b-form-input>
        </b-form-group>
        <b-form-group label="Tipo de rejilla" label-for="containerSelect">
          <v-select
            label="text"
            required
            disabled
            v-model="container"
            :options="containerOptions"
            @option:selected="fetchContainerData($event)"
          >
            <template #footer>
              <div class="ml-2 text-info" v-if="containerData">
                Peso de la rejilla: {{ containerData.material_weight }}Kg
              </div>
            </template>
          </v-select>
        </b-form-group>
        <b-form-group label="Cantidad" label-for="quantity">
          <b-form-input id="quantity" v-model="quantity" type="number" min="0" disabled required></b-form-input>
        </b-form-group>
        <b-form-group
          label="Kilos Netos"
          label-for="net_kilograms"
          :description="'Kilos restantes ' + remainingKilograms + 'Kg'"
        >
          <b-form-input
            id="net_kilograms"
            :value="net_kilograms"
            type="number"
            min="0"
            disabled
            required
          ></b-form-input>
        </b-form-group>
        <b-form-group label="% Deshidratación" label-for="dh">
          <b-form-input
            id="dh"
            v-model="dh"
            type="number"
            min="0"
            :disabled="loading || hereLoading"
            required
          ></b-form-input>
        </b-form-group>
        <b-form-group
          label="Kilos Netos - DH"
          label-for="net_kilograms_dh"
          :description="netKilogramsWithDh / quantity"
        >
          <b-form-input id="net_kilograms_dh" :value="netKilogramsWithDh" type="number" min="0" disabled></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-button block @click.prevent="hideModal()">Cancelar</b-button>
      </b-col>
      <b-col>
        <b-button
          block
          :disabled="!allFieldsComplete || hereLoading || exeedMaxKilograms"
          variant="primary"
          @click.prevent="onSubmit"
        >
          <b-spinner small v-if="hereLoading"></b-spinner>
          <span v-else>Crear</span>
        </b-button>
      </b-col>
    </b-row>
  </b-form>
</template>
<script>
import { mapState } from "vuex";
export default {
  name: "CreateExportableBulk",
  props: ["loading", "containerOptions", "lot_id", "process_id", "product_type", "modal_name", "max_kilograms"],
  data() {
    return {
      title: "Crear Contenido",
      gross_kilograms: null,
      net_kilograms: null,
      pallet_weight: null,
      container: null,
      quantity: null,
      dh: null,
      containerData: null,
      hereLoading: false,
      item: null
    };
  },
  methods: {
    handlePalletChange(event) {
      const pallet = event;
      this.gross_kilograms = pallet.gross_kilograms;
      this.net_kilograms = pallet.net_kilograms;
      this.pallet_weight = 0;
      this.item = pallet;
      this.quantity = pallet.quantity;
      this.container = {
        value: pallet.container_id,
        text: pallet.container_name
      };
    },
    clearForm() {
      this.gross_kilograms = null;
      this.pallet_weight = null;
      this.container = null;
      this.quantity = null;
      this.dh = null;
      this.containerData = null;
    },
    formIncompleteAlert() {
      this.$bvToast.toast("Faltan campos por completar", {
        title: "Error",
        variant: "danger",
        solid: true
      });
    },
    async fetchContainerData(event) {
      this.hereLoading = true;
      try {
        await this.$axios
          .get("/api/v1/container/" + event.value + "/")
          .then((response) => {
            this.containerData = response.data.value;
          })
          .catch((error) => {
            console.log(error);
          });
      } catch (error) {
        console.log(error);
      } finally {
        this.hereLoading = false;
      }
    },
    hideModal() {
      this.$bvModal.hide(this.modal_name);
      this.clearForm();
    },
    async onSubmit() {
      const payload = {
        gross_kilograms: this.gross_kilograms,
        pallet_weight: this.pallet_weight,
        container: this.container,
        quantity: this.quantity,
        exportable_kilograms: this.netKilogramsWithDh,
        net_kilograms: this.net_kilograms,
        lot_id: this.lot_id,
        process_id: this.process_id,
        product_type_id: this.product_type.value
      };
      this.hereLoading = true;
      try {
        const res = await this.$axios.post("/api/v1/process/traceability_out_exportable_bulk/", payload);
        this.$store.dispatch("alfaberriesProcess/addRowsOut", res.data);
        this.$bvToast.toast("Creado con éxito", {
          title: "Éxito",
          variant: "success",
          solid: true
        });
        this.$bvModal.hide(this.modal_name);
        this.clearForm();
      } catch (error) {
        console.log(error);
        this.$bvToast.toast("Error al crear", {
          title: "Error",
          variant: "danger",
          solid: true
        });
      } finally {
        this.hereLoading = false;
      }
      console.log(payload);
    }
  },
  computed: {
    ...mapState("alfaberriesProcess", {
      contents_in: (state) => state.form.contents_in
    }),
    palletList() {
      return this.contents_in.map((item) => {
        return {
          value: item,
          text: item.pallet_number
        };
      });
    },
    remainingKilograms() {
      return (this.max_kilograms - this.net_kilograms).toFixed(2);
    },
    exeedMaxKilograms() {
      return this.remainingKilograms < 0;
    },
    allFieldsComplete() {
      return this.gross_kilograms && this.dh && this.container && this.quantity;
    },
    netKilogramsWithDh() {
      const net = parseFloat(this.net_kilograms);
      const overweight = (net * this.dh) / 100;
      return net - overweight;
    }
  }
};
</script>
<style></style>
